import { createTheme } from '@mui/material';

const defaultTheme = createTheme({
  // place global mui theme options here
});

export default defaultTheme;
